import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import SignaturePad from 'signature_pad';

@Component({
    selector: 'customer-sign',
    templateUrl: 'customer-sign.html',
    styleUrls: ['customer-sign.scss'],
    standalone: false
})
export class CustomerSignComponent implements AfterViewInit {
    signForm: FormGroup;
    @ViewChild('canvas', { static: false }) canvasEl: ElementRef<HTMLCanvasElement>;
    signaturePad: SignaturePad;

    constructor(public modalCtrl: ModalController, private formBuilder: FormBuilder) {
        this.signForm = formBuilder.group({
            sign: ['', Validators.compose([Validators.required])]
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.canvasEl && this.canvasEl.nativeElement) {
                const canvas = this.canvasEl.nativeElement;
                const wrapper = canvas.parentElement;
                
                // Set canvas size to match container
                if (wrapper) {
                    canvas.width = wrapper.clientWidth - 4;
                    canvas.height = 200;
                }
                
                // Initialize signature pad
                this.signaturePad = new SignaturePad(canvas, {
                    minWidth: 1,
                    maxWidth: 3,
                    backgroundColor: 'rgb(255, 255, 255)',
                    penColor: 'rgb(0, 0, 0)',
                    velocityFilterWeight: 0.7
                });
                
                // Listen to drawing events
                this.signaturePad.addEventListener('endStroke', () => {
                    this.drawComplete();
                });
                
                console.log('SignaturePad initialized successfully');
            } else {
                console.error('Canvas element not found!');
            }
        }, 200);
    }

    drawComplete() {
        if (this.signaturePad && !this.signaturePad.isEmpty()) {
            const dataUrl = this.signaturePad.toDataURL();
            this.signForm.get('sign').setValue(dataUrl);
        }
    }

    clearSignature() {
        if (this.signaturePad) {
            this.signaturePad.clear();
            this.signForm.get('sign').setValue('');
        }
    }

    addSign() {
        const sign = this.signForm.get('sign').value;
        this.modalCtrl.dismiss({ Sign: sign });
    }

    dismiss() {
        this.modalCtrl.dismiss();
    }
}
